// extracted by css-extract-rspack-plugin
export default {"ViewsBackLink":"ViewsBackLink-module__ViewsBackLink__d8n2R"};